import { ITextProps, Text } from '@fluentui/react'
import * as React from 'react'
import { ReactElement } from 'react'

type Props = {
    value?: string
    unit?: string
    textProps?: ITextProps
}

export default function DistanceText({ value, unit, textProps }: Props): ReactElement {
    if (!value) {
        return <></>
    }

    const text = (
        <>
            {parseInt(value)}
            <small> {unit || 'km'}</small>
        </>
    )

    return textProps ? <Text {...textProps}>{text}</Text> : text
}
